/**
 * This is import script.js file
 */
export default  {
    name: 'UploadDetail',
    /**
     * @override
     */
    data() {
        return {
            totalRows: 0,
            currentPage: 1,
            perPage: 5,
            pageOptions: [ 5, 10, 15 ],
            sortBy: 'filerecord',
            sortDesc: false,
            sortDirection: 'asc',
            filterOn: [],
            filter: null,
            filterByOptions: [
                { value: 'none', text: 'todos' },
                { value: 'SUCCESS', text: 'importados' },
                { value: 'ERROR', text: 'errores' },
                { value: 'DUPLICATED', text: 'duplicados' }
            ],
            filterBy: 'none',
            records: []
        };
    },
    props: {
        uuid: {
            type: String,
            required: false
        }
    },
    watch: {
        total(n) {
            this.totalRows = n;
        },
        filterBy(n) {
            if (n === 'none') {
                this.clearFilters();
            } else {
                this.filterBySuccess(n);
            }
        },
        uuid: {
            immediate: true,
            handler(n) {
                this.fetchFilerecords(n);
            }
        }
    },
    methods: {
        /**
         * @override
         */
        filterBySuccess(value) {
            this.filterOn = [ 'result' ];
            this.filter = value;
        },
        /**
         * @override
         */
        clearFilters() {
            this.filterOn = [];
            this.filter = null;
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        /**
         * @override
         */
        recordIconClass(result) {
            let i = '';
            switch (result) {
                case 'SUCCESS':
                    i = 'fa-check color-brand';
                    break;
                case 'DUPLICATED':
                    i = 'fa-times color-gray';
                    break;
                default:
                    i = 'fa-times color-error';
                    break;
            }
            return i;
        },
        fetchFilerecords(uuid) {
            if (!uuid) {
                return;
            }
            this.$importService.listUploadFilerecords(uuid)
                .then(res => {
                    this.$set(this, 'records', res.data.filerecords);
                });
        }
    },
    computed: {
        summaryItems() {
            return this.records;
        },
        total() {
            return this.records ? this.records.length : 0;
        },
        summaryFields() {
            return [
                {
                    key: 'result',
                    label: ' ',
                    sortable: false
                },
                {
                    key: 'filerecord',
                    label: 'Registro',
                    sortable: true
                },
                {
                    key: 'created_on',
                    label: 'Fecha',
                    sortable: false
                },
                {
                    key: 'message',
                    label: 'Error',
                    sortable: false
                },
                {
                    key: 'show_details',
                    label: '',
                    sortable: false
                }
            ];
        },
        currentRange() {
            return [
                Number(this.perPage) * (this.currentPage - 1) + 1,
                Number(this.perPage) * this.currentPage
            ];
        }
    }

};
